module.exports = __webpack_public_path__ + "645fe6579353ef54e1b2850e57c70264.png";